import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import PropTypes from 'prop-types'

export class CustomScrollbars extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      hover: false
    }
  }

  render () {
    return (
      <Scrollbars universal
        renderThumbVertical={({ style, ...props }) =>
          <div {...props} style={{ ...style, backgroundColor: 'rgba(255,255,255,0.2)' }} />
        }>
        {this.props.children}
      </Scrollbars>
    )
  }
}

CustomScrollbars.propTypes = {
  children: PropTypes.node
}
